import React from 'react';

import { LazyImportSpacesPage } from '@confluence/site-settings/entry-points/ImportSpacesPage.ts';
import { ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/importSpacesConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminImportSpacesRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazyImportSpacesPage />;

AdminImportSpacesRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
